import { AnimatedIconRef } from "components/AnimatedIcon/AnimatedIcon";
import { Chip, DeepSearchIcon, MeterIcon } from "design_system";
import { ExampleQueriesCategory } from "helpers/api";
import { List, TableProperties } from "lucide-react";
import { ReactElement, useCallback, useRef } from "react";

const EXAMPLE_QUERY_CATEGORY_TO_ICON: Record<string, ReactElement> = {
  research_questions: <DeepSearchIcon size="sm" />,
  draft_outlines: <List size={20} />,
  create_tables: <TableProperties size={20} />,
  yes_no_questions: <MeterIcon size="sm" />,
};

type ExampleQueryButtonsProps = {
  exampleQueries: ExampleQueriesCategory[];
  onCategoryClick: (queries: string[]) => void;
};

const ExampleQueryButtons = ({
  exampleQueries,
  onCategoryClick,
}: ExampleQueryButtonsProps) => {
  const deepSearchIconRef = useRef<AnimatedIconRef>(null);

  const handleDeepSearchMouseEnter = useCallback(() => {
    if (deepSearchIconRef.current) {
      deepSearchIconRef.current.startAnimation();
    }
  }, []);

  const handleDeepSearchMouseLeave = useCallback(() => {
    if (deepSearchIconRef.current) {
      deepSearchIconRef.current.stopAnimation();
    }
  }, []);

  return (
    <div className="flex flex-wrap gap-2 justify-center mt-6">
      {exampleQueries.map((category) => (
        <Chip
          key={category.key}
          size="sm"
          iconLeft={EXAMPLE_QUERY_CATEGORY_TO_ICON[category.key]}
          onClick={() => onCategoryClick(category.queries)}
          onMouseEnter={handleDeepSearchMouseEnter}
          onMouseLeave={handleDeepSearchMouseLeave}
        >
          {category.title}
        </Chip>
      ))}
    </div>
  );
};

export default ExampleQueryButtons;
